export default "__VITE_ASSET__BOPgToKt__"